export const initialDataState = {
  sort: [
    {
      field: "code",
      dir: "asc",
    },
  ],
};

export const SERVICE_POINT_INFORMATION = {
  customerId: "",
  billingCustomerId: "",
  contractCode: "",
  cashCenterId: "",
  locationId: "",
  locationName: "",
  locationCode: "",
  category: "",
  routeNo: "",
  locationType: "",
  status: "",
  siteType: "",
  fixingSide: "",
  loadingSide: "",
  machineType: "",
  maker: "",
  model: "",
  lockSerialNo: "",
  machineSerialNo: "",
  barcode: "",
  siteLimit: "",
  distanceFromBase: 0,
  coLocatedGroupNo: 0,
  maximumCassettes: 0,
  requiresCashierCount: true,
  requiresEVhr: true,
  hasSecurityAlarm: false,
  alarmDetails: "",
  country: "",
  state: "",
  emirate: "",
  city: "",
  address: "",
  longitude: 0,
  latitude: 0,
  lockInstallationDate: null,
  firstServiceDate: null,
  decomissionedDate: null,
  followStandardModels: true,
  followStandardDenominations: true,
  followStandardCassettes: true,
  followsCustomerServiceWindows: true,
  dedicatedSerials: [],
  serviceDays: [],
  allowedDays: [],
  siteSLAs: [],
  operationalWindows: [],
  serviceWindows: [],
  cassettes: [],
  denominations: [],
  replenishmentModels: [],
  siteRepresentatives: [],
  onwardLocations: [],
  serviceSchedules: [],
  requestedBy: "",
  comments: "",

  numberOfCassettes: 0,
  numberOfBins: 0,
  numberOfKeys: 0,

  hasCamera: 1,

  cameraType: "",

  area: "",

  machineInstallationDate: new Date(),
};
export const SERVICE_SCHEDULES_DEFAULT = {
  scheduleType: "",
  serviceType: "",
  jobType: "",
  routeNo: "",
  weekDays: [],
  monthDates: [],
};

export const LOCATION_TYPES = [
  {
    value: "Branch",
    label: "Branch",
  },
  {
    value: "VIP",
    label: "VIP",
  },
  {
    value: "Hub",
    label: "Hub",
  },
  {
    value: "ATM",
    label: "ATM",
  },
  {
    value: "CDM",
    label: "CDM",
  },
  {
    value: "Combo",
    label: "Combo",
  },
  {
    value: "ITM",
    label: "ITM",
  },
  {
    value: "Recycler",
    label: "Recycler",
  },
  {
    value: "KIOSK",
    label: "KIOSK",
  },
  {
    value: "SCDM",
    label: "SCDM",
  },
  {
    value: "Cash Center",
    label: "Cash Center",
  },
  { value: "EPM", label: "EPM" },
  { value: "PPM", label: "PPM" },
  { value: "MAXBOX", label: "MAXBOX" },
  { value: "Corporate", label: "Corporate" },
  { value: "Bank", label: "Bank" },
  { value: "Direct", label: "Direct" },
  { value: "Central Bank", label: "Central Bank" },
  { value: "Retail", label: "Retail" },
];

export const STATUS_LIST = [
  { value: "Active", label: "Active" },
  { value: "Decommissioned", label: "Decommissioned" },
];

export const CATEGORY_LIST = [
  { value: "A", label: "A" },
  { value: "B", label: "B" },
  { value: "C", label: "C" },
];

export const BAG_TYPE_LIST = [
  { value: "1", label: "Pouch Bag" },
  { value: "2", label: "Pouch Bag (Medium)" },
  { value: "3", label: "Foreign Currency" },
];

export const SITE_TYPE_LIST = [
  {
    value: "CIT",
    label: "CIT",
  },
  {
    value: "Machine",
    label: "Machine",
  },
];

export const FIXING_SIDE = [
  {
    value: "Drive Up Island",
    label: "Drive Up Island",
  },
  {
    value: "Lobby Room Window",
    label: "Lobby Room Window",
  },
  {
    value: "Drive Up Kiosk",
    label: "Drive Up Kiosk",
  },
  {
    value: "Lobby Stand Alone",
    label: "Lobby Stand Alone",
  },
];

export const LOADING_SIDE_LIST = [
  { value: "Front", label: "Front" },
  { value: "Rear", label: "Rear" },
];
export const WEEK_DAYS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export const siteSLADefault = {
  region: "",
  serviceType: "",
  activityType: "",
  responseTime: "0",
  attendedTime: "0",
  resolutionTime: "0",
};
export const OPERATION_WINDOW_DEFAULT = {
  startDateTime: new Date(),
  endDateTime: new Date(),
  cutOffTime: new Date(),
};
export const SERVICE_WINDOW_DEFAULT = {
  startDateTime: new Date(),
  endDateTime: new Date(),
  cutOffTime: new Date(),
};
export const denominationDefault = {
  currency: null,
  multiple: null,
  noOfCassettes: "0",
  noOfNotes: "0",
};

export const replenishmentModelsDefault = {
  code: "",
  ...denominationDefault,
  denominations: [],
  models: [],
};

export const CASSETTES_DEFAULT = {
  description: "",
  currency: "",
  multiple: "",
  cassetteType: "",
  maker: "",
  limit: 0,
  dualScanning: true,
};

export const DENOMINATIONS_DEFAULT = {
  currency: "",
  multiple: "",
  shape: "",
  version: "",
};

export const CASSETTES_TYPE = [
  {
    value: "Type 1",
    label: "Type 1",
  },
  {
    value: "Type 2",
    label: "Type 2",
  },
  {
    value: "Type 3",
    label: "Type 3",
  },
  {
    value: "Type 4",
    label: "Type 4",
  },
  {
    value: "Type 5",
    label: "Type 5",
  },
  {
    value: "Type 6",
    label: "Type 6",
  },
  {
    value: "Cash Bin",
    label: "Cash Bin",
  },
  {
    value: "Reject Bin",
    label: "Reject Bin",
  },
];
export const CASSETTES_DESCRIPTIONS = [
  {
    value: "ATM Cassette",
    label: "ATM Cassette",
  },
  {
    value: "CDM Cassette",
    label: "CDM Cassette",
  },
  {
    value: "ATM Reject Bin",
    label: "ATM Reject Bin",
  },
  {
    value: "CDM Cash Bin",
    label: "CDM Cash Bin",
  },
];

export const _DEFAULT_SITE_REPRESENTATIVE = {
  name: "",
  employeeId: "",
  mobileNo: "",
  email: "",
};

export const _CAMERA_TYPES = [
  { label: "Pinhole", value: "Pinhole" },
  { label: "Dome Camera", value: "Dome Camera" },
];

export const _SCHEDULED_TYPES = [
  { label: "Weekly", value: "Weekly" },
  { label: "Monthly", value: "Monthly" },
];
